module.exports = __webpack_public_path__ + "static/media/40-6.4605b6cf.mp3";